<template>
  <div class="voucher-management">
    <div class="container-fluid">
      <h3 class="my-3">
        Danh sách E Voucher
      </h3>
      <div class="content">
        <div class="tab-header">
          <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item start">
              <a class="nav-link active start" href="#all" role="tab" data-toggle="tab">{{ $t('voucherManagement.all') }} (1)</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#confirm" role="tab" data-toggle="tab">{{ $t('voucherManagement.waitForConfirmation') }} (2)</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#using" role="tab" data-toggle="tab">{{ $t('voucherManagement.using') }} (3)</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#notInUseYet" role="tab" data-toggle="tab">{{ $t('voucherManagement.notUseYet') }} (3)</a>
            </li>
            <li class="nav-item end">
              <a class="nav-link end" href="#used" role="tab" data-toggle="tab">{{ $t('voucherManagement.used') }} (3)</a>
            </li>
          </ul>
        </div>

        <div class="button-confirm">
          <p class="space"></p>
          <button type="button" class="btn btn-outline-success">Xác nhận</button>
        </div>

        <!-- Tab panes -->
        <div class="tab-content">
           <div role="tabpanel" class="tab-pane fade active show" id="all">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col" class="table-header">
                    <label class="checkbox path" style="margin-bottom:-4.5px;">
                      <input type="checkbox" @click="selectAll(this)">
                      <svg viewBox="0 0 21 21">
                          <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
                      </svg>
                    </label>
                  </th>
                  <th scope="col" class="table-header"><span>{{ $t('voucherManagement.table.numericalOrder') }}</span></th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.image') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.voucherSerial') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.voucherName') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.status') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.amount') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.denominations') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.totalMoney') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.amountUsed') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.theRemainingAmount') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.moneySpent') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.moneyRemaining') }}</th>
                  <th scope="col" class="table-header">{{ $t('voucherManagement.table.action') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>
                    <label class="checkbox path" style="margin-bottom:-4.5px;">
                      <input type="checkbox" name='name[]' id='check_all' value=''>
                      <svg viewBox="0 0 21 21">
                          <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
                      </svg>
                    </label>
                  </th>
                  <th scope="row">1</th>
                  <td>Hình ảnh</td>
                  <td><a href="#">ABC1</a></td>
                  <td><a href="#">voucher1</a></td>
                  <td>trạng thái</td>
                  <td>1</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>Xác nhận</td>
                </tr>
                <tr>
                  <th>
                    <label class="checkbox path" style="margin-bottom:-4.5px;">
                      <input type="checkbox" name='name[]' id='check_all' value=''>
                      <svg viewBox="0 0 21 21">
                          <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
                      </svg>
                    </label>
                  </th>
                  <th scope="row">2</th>
                  <td>Hình ảnh</td>
                  <td><a href="#">ABC2</a></td>
                  <td><a href="#">voucher2</a></td>
                  <td>trạng thái</td>
                  <td>1</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>Xác nhận</td>
                </tr>
                <tr>
                  <th>
                    <label class="checkbox path" style="margin-bottom:-4.5px;">
                      <input type="checkbox" name='name[]' id='check_all' value=''>
                      <svg viewBox="0 0 21 21">
                          <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
                      </svg>
                    </label>
                  </th>
                  <th scope="row">3</th>
                  <td>Hình ảnh</td>
                  <td><a href="#">ABC3</a></td>
                  <td><a href="#">voucher3</a></td>
                  <td>trạng thái</td>
                  <td>1</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>1000</td>
                  <td>Xác nhận</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div role="tabpanel" class="tab-pane fade" id="confirm">Chờ xác nhận</div>
          <div role="tabpanel" class="tab-pane fade" id="using">Đang sử dụng</div>
          <div role="tabpanel" class="tab-pane fade" id="notInUseYet">Chưa sử dụng</div>
          <div role="tabpanel" class="tab-pane fade" id="used">Đã sử dụng</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSelectAll: false,
    }
  },
  methods: {
    selectAll() {
      this.isSelectAll = !this.isSelectAll
      if (this.isSelectAll === true) {
        const checkboxes = document.getElementsByName('name[]');
        for (let i = 0; i < checkboxes.length; i++){
          checkboxes[i].checked = true;
        }
      }
      else {
        const checkboxes = document.getElementsByName('name[]');
        for (let i = 0; i < checkboxes.length; i++){
          checkboxes[i].checked = false;
        }
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
}
</script>

<style lang="scss" scoped>
  .voucher-management {
    a {
      text-decoration: none;
      color: #3CB371;

      &:hover {
        color: #84dcab;
      }
      &:active {
        color: #3CB371;
      }
    }
    .container-fluid {
      .tab-header {
        ul {
          width: fit-content;
          border: none;
          border: 1px solid #3CB371;
          border-radius: 10px;
          margin: 0 auto;
          .nav-item {
            border-left: 1px solid #3CB371;
            .nav-link {
              border: none;
              color: #3CB371;

              &.active {
                color: #fff;
                background-color: #3CB371;
                border-radius: 0;
                margin: 0;
              }

              &.start {
                border-radius: 10px 0 0 10px;
              }

              &.end {
                border-radius: 0 10px 10px 0;
              }
            }

            &.start {
              border: none;
            }
          }
        }
      }

      .button-confirm {
        display: flex;
        justify-content: space-around;
        margin: 20px 0;
      }

      .tab-content {
        margin-top: 45px;

        .table {
          .checkbox {
            --background: #fff;
            --border: #D1D6EE;
            --border-hover: #BBC1E1;
            --border-active: #1E2235;
            --tick: #fff;
            position: relative;
            input,
            svg {
                width: 21px;
                height: 21px;
                display: block;
            }
            input {
                -webkit-appearance: none;
                -moz-appearance: none;
                position: relative;
                outline: none;
                background: var(--background);
                border: none;
                margin: 0;
                padding: 0;
                cursor: pointer;
                border-radius: 4px;
                transition: box-shadow .3s;
                box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--border));
                &:hover {
                    --s: 2px;
                    --b: var(--border-hover);
                }
                &:checked {
                    --b: var(--border-active);
                }
            }
            svg {
                pointer-events: none;
                fill: none;
                stroke-width: 2px;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke: var(--stroke, var(--border-active));
                position: absolute;
                top: 0;
                left: 0;
                width: 21px;
                height: 21px;
                transform: scale(var(--scale, 1)) translateZ(0);
            }
            &.path {
                input {
                    &:checked {
                        --s: 2px;
                        transition-delay: .4s;
                        & + svg {
                            --a: 16.1 86.12;
                            --o: 102.22;
                        }
                    }
                }
                svg {
                    stroke-dasharray: var(--a, 86.12);
                    stroke-dashoffset: var(--o, 86.12);
                    transition: stroke-dasharray .6s, stroke-dashoffset .6s;
                }
            }
          }

          tr {
            .table-header {
              background-color: #3CB371;
              border-color: #eee;
            }
          }
        }
      }
    }
  }
</style>